exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".socialRequestsTotalItem-f9c2e{display:flex;justify-content:space-between;align-items:center;margin-bottom:7px}.socialRequestsTotalItem-f9c2e .value-07483{font-style:normal;font-weight:400;font-size:14px;text-align:right;color:#262626}.socialRequestsTotalItem-f9c2e .title-ebde6{font-style:normal;font-weight:400;font-size:14px;margin-right:10px;color:#bfbfbf}", ""]);

// Exports
exports.locals = {
	"socialRequestsTotalItem": "socialRequestsTotalItem-f9c2e",
	"value": "value-07483",
	"title": "title-ebde6"
};